import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { BootstrapDatePickerComponent } from '../shared/components/ng-date-picker.component';
import {
  AssessmentSummary, DateUtility, SINGLE_ROW_HEADER, DELETE_BTN,
  AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS,
  AUDIT_PAGE_TITLE, AgGridUtility
} from '../shared';
import { CommonUtility, ServerConstantsService, DataService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';

@Component({
  selector: 'app-barriers',
  templateUrl: './barriers.component.html',
  styleUrls: ['./barriers.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class BarriersComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText: ElementRef;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  isDisabled = false;
  familySw: String;
  tabIndex: any = '-1';
  personalSw: String;
  transportSw: String;
  isFamily = false;
  isTransport = false;
  isPersonal = false;
  barriers: Barries[] = [];
  removeBarries: Barries[] = [];
  assessmentId;
  assessment: AssessmentSummary;
  notes = '';
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;

  transBarrierNameDescJson: any;
  transBarrierNameDescReverseJson: any;
  userActionNotificationsMap: any;


  barrierTypeDescJson: any;
  barrierTypeDescReverseJson: any;


  familyBarrierNameDescJson: any;
  familyBarrierNameDescReverseJson: any;


  personalBarrierNameDescJson: any;
  personalBarrierNameDescReverseJson: any;
  isCurrentEnrollment:Boolean = false;

  serverConstants: any;
  sharedData: any;

  columnDefs: any;
  auditColumnDefs: any;
  testContext: any;
  familyArray = [];
  personalArray = [];
  transArray = [];
  typeArray = [];
  rowSelection;
  context: any;
  gridApi;
  gridColumnApi;
  components;
  defaultColDef;
  editType;
  gridOptions;

  selectedBarriersNames;
  selectedBarriersReverse;
  allBarriersNames;
  allBarriersNameCodes;
  selectedBarriers;

  validationError = [];
  showError = false;

  isShowStyle = false;
  isChangeDetected = false;
  readOnly = false;
  tabToNextCell: any;
  frameworkComponents

  constructor(

    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    this.selectedBarriers = [];
    if (this.dataService.getSharedDataObject().get('ASMNT') === undefined) {
      this.router.navigate(['/task']);
    }

  }

  ngOnInit() {

    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get('ASMNT').innerNavPages.find(x => x.pageId === 'ASMBC').readOnly;
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    const barrierTypeDesc = this.data.getValueFromSharedDataMap('BarrierTypeDesc');
    barrierTypeDesc.forEach(element => {
      this.typeArray.push(element.name);
    });

    this.barrierTypeDescJson = this.commonUtil.createNativeMapFromList(barrierTypeDesc);
    this.selectedBarriers = [];
    this.selectedBarriers.push('Pick an option');
    this.selectedBarriers.push(this.barrierTypeDescJson['FA']);
    this.selectedBarriers.push(this.barrierTypeDescJson['PE']);
    this.selectedBarriers.push(this.barrierTypeDescJson['TR']);
    this.barrierTypeDescReverseJson = this.commonUtil.createReverseNativeMapFromList(barrierTypeDesc);

    const familyBarrierNameDesc = this.data.getValueFromSharedDataMap('FamilyBarrierNameDesc');
    familyBarrierNameDesc.forEach(element => {
      this.familyArray.push(element.name);
    });
    this.familyBarrierNameDescJson = this.commonUtil.createNativeMapFromList(familyBarrierNameDesc);
    this.familyBarrierNameDescReverseJson = this.commonUtil.createReverseNativeMapFromList(familyBarrierNameDesc);

    const personalBarrierNameDesc = this.data.getValueFromSharedDataMap('PersonalBarrierNameDesc');
    personalBarrierNameDesc.forEach(element => {
      this.personalArray.push(element.name);
    });
    this.personalBarrierNameDescJson = this.commonUtil.createNativeMapFromList(personalBarrierNameDesc);
    this.personalBarrierNameDescReverseJson = this.commonUtil.createReverseNativeMapFromList(personalBarrierNameDesc);

    const transportationBarrierNameDesc = this.data.getValueFromSharedDataMap('TransportationBarrierNameDesc');
    transportationBarrierNameDesc.forEach(element => {
      this.transArray.push(element.name);
    });
    this.transBarrierNameDescJson = this.commonUtil.createNativeMapFromList(transportationBarrierNameDesc);
    this.transBarrierNameDescReverseJson = this.commonUtil.createReverseNativeMapFromList(transportationBarrierNameDesc);

    this.selectedBarriersNames = {
      Family: this.familyArray,
      Personal: this.personalArray,
      Transportation: this.transArray
    };


    this.selectedBarriersReverse = {
      Family: this.familyBarrierNameDescReverseJson,
      Personal: this.personalBarrierNameDescReverseJson,
      Transportation: this.transBarrierNameDescReverseJson
    };

    this.allBarriersNames = {
      Family: this.familyBarrierNameDescJson,
      Personal: this.personalBarrierNameDescJson,
      Transportation: this.transBarrierNameDescJson
    };

    this.allBarriersNameCodes = {
      'FA': this.familyBarrierNameDescJson,
      'PE': this.personalBarrierNameDescJson,
      'TR': this.transBarrierNameDescJson
    };

    // Shared object access to get personId and assessmentId
    const sharedData = this.dataService.getSharedDataObject();

    if (sharedData.get('assessmentId') !== null && sharedData.get('assessmentId') !== undefined) {
      this.assessmentId = Number(sharedData.get('assessmentId'));
    }

    this.getColumnDefinitions();
    this.getAuditColumnDefinitions();


    if (this.assessmentId > 0) {
      const request = new RequestLoad(this.assessmentId);
      this.load(request);

    }

    if (sharedData.get('selectedEnrollmentEndDt') !== null && sharedData.get('selectedEnrollmentEndDt') !== undefined
    && sharedData.get('selectedEnrollmentEndDt') !== "Current") {
      this.isCurrentEnrollment = false;
    } else {
      this.isCurrentEnrollment = true
    }

    console.log('isDisabled : ' + this.isDisabled);
    console.log('readOnly : ' + this.readOnly);
    console.log('isCurrentEnrollment : ' + this.isCurrentEnrollment);
    console.log('selectedEnrollmentEndDt : ' + sharedData.get('selectedEnrollmentEndDt'));
    
  }
  focusing(event) {
    if (!event.shiftKey && event.keyCode == 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
      this.headerText.nativeElement.click();
    }
  }



  getColumnDefinitions() {
    this.columnDefs = [
      {
        headerName: 'Barrier Type', width: 140, field: 'barrierTypeCd',
        editable: !(this.isDisabled || this.readOnly), cellEditor: 'agSelectCellEditor',
        cellEditorParams: function (params) {

          const that = params.api.gridCore.gridOptions.context.component;

          return {
            values: that.selectedBarriers,

          };


        }, cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && params.value === 'Pick an option') {

              return { border: '1px solid red' };
            } else {
              if (params.value !== undefined && params.value !== 'Pick an option' && (params.data.barrierCd === undefined)) {
                params.data.barrierCd = 'Pick an option';
              }

              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Barrier', field: 'barrierCd', editable: !(this.isDisabled || this.readOnly), cellEditor: 'agSelectCellEditor',
        cellEditorParams: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            const selectedCountry = params.data.barrierTypeCd;
            let allowedBarriersNames = that.selectedBarriersNames[selectedCountry];
            allowedBarriersNames = allowedBarriersNames.slice(1);
            allowedBarriersNames.sort();
            allowedBarriersNames.unshift("Pick an option");
            return {
              values: allowedBarriersNames,

            };
          }
        }, cellStyle: function (params) {
          const selectedBarrierType = params.data.barrierTypeCd;
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && (selectedBarrierType === undefined
              || params.value === undefined || params.value === 'Pick an option')) {

              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'Begin Date', width: 140, field: 'beginDt',
        editable: !(this.isDisabled || this.readOnly), cellEditor: 'datePicker', cellStyle: function (params) {
          if (params.api !== null) {
            const that = params.api.gridCore.gridOptions.context.component;
            if (that.isShowStyle && (params.value === undefined || params.value.trim().length === 0)) {
              return { border: '1px solid red' };
            } else {
              return { border: 'none' };
            }
          }
        },
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },
      {
        headerName: 'End Date', width: 140, field: 'endDt', editable: !(this.isDisabled || this.readOnly), cellEditor: 'datePicker',
        onCellValueChanged: function (params) {
          const that = params.api.gridCore.gridOptions.context.component;
          that.isChangeDetected = true;
        }
      },

      {
        headerName: 'Action', width: 110, field: '', cellRenderer: this.getActionButtons,
        suppressFilter: true,
        suppressSorting: true
      },
    ];

    this.context = {
      component: this,
    };
    this.rowSelection = 'multiple';
    // this.components = { datePicker: this.getDatePicker() };
    this.frameworkComponents = {
      datePicker: BootstrapDatePickerComponent,
    };
    this.gridOptions = {
      context: {
        componentParent: this
      }
    };
    this.tabToNextCell = function tabToNextCell(params) {
      const nextCell = params.nextCellDef;
      if (nextCell.column.colDef.headerName === 'Action') {
        return;
      } else {
        return nextCell;
      }
    };
  }

  getAuditColumnDefinitions() {
    this.auditColumnDefs = [
      {
        headerName: 'Modified By',
        field: 'createdBy',
        tooltipField: 'createdBy'
      },
      {
        headerName: 'Modified Date',
        field: 'createdDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDateTime,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDateTime,
      },
      {
        headerName: 'Barrier Type',
        field: 'barrierTypeCd',
        refData: this.barrierTypeDescJson,
        tooltip: (params) => {
          const barrierTypeDescMap = params.context.barrierTypeDescJson;
          const barrierTypeCode = params.data.barrierTypeCd;
          const barrierType = barrierTypeDescMap[barrierTypeCode];
          return barrierType;
        }
      },
      {
        headerName: 'Barrier',
        field: 'barrierCd',
        valueGetter: this.getBarrier,
        tooltip: this.getBarrier,
      },
      {
        headerName: 'Begin Date',
        field: 'beginDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
      {
        headerName: 'End Date',
        field: 'endDt',
        filter: 'agDateColumnFilter',
        valueFormatter: this.agGridUtility.formatTimeDateToDate,
        filterParams: {
          comparator: this.agGridUtility.filterDates
        },
        tooltip: this.agGridUtility.formatTimeDateToDate
      },
    ];
  }

  getBarrier(params) {
    const mapBarrierCode = params.context.allBarriersNameCodes;
    const barrierTypeCode = params.data.barrierTypeCd;
    const barrierCode = params.data.barrierCd;
    const selectedBarrierTypeCd = mapBarrierCode[barrierTypeCode];
    const slectedBarrierCd = selectedBarrierTypeCd[barrierCode];

    return slectedBarrierCd;
  }
  addEventListenerToSearch(event) {
    const tabKeyCode = 9;

    // ignore non tab key strokes 
    if (event.keyCode !== tabKeyCode) {
      return;
    }
    if (this.barriers.length === 0) {
      return;
    }

    if (event.shiftKey) {
      return true; // unbind preventDefault when navigating backwards
    } else {
      // prevents tabbing into the url section when navigating forward
      event.preventDefault();
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    const index = this.gridApi.getFirstDisplayedRow();
    const rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row 
    //this.gridApi.ensureIndexVisible(0, 'top');

    // scrolls to the first column 
    const firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell 
    this.gridApi.setFocusedCell(index, firstCol);
  }

  getDatePicker() {


    function Datepicker() { }
    Datepicker.prototype.init = function (params) {
      this.eInput = document.createElement('input');
      this.eInput.value = params.value;

      ($(this.eInput) as any).datepicker({ dateFormat: 'mm/dd/yy' });
    };
    Datepicker.prototype.getGui = function () {
      return this.eInput;
    };
    Datepicker.prototype.afterGuiAttached = function () {
      this.eInput.focus();
      this.eInput.select();
    };
    Datepicker.prototype.getValue = function () {
      return this.eInput.value;
    };
    Datepicker.prototype.destroy = function () { };
    Datepicker.prototype.isPopup = function () {
      return false;
    };
    return Datepicker;
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();

  }

  onResize(event) {
    if (window.screen.width >= window.innerWidth) {
      this.gridApi.columnDefs = this.columnDefs;
    } else {
      this.gridApi.sizeColumnsToFit();
    }
  }

  getActionButtons(params) {
    const that = params.context.component;

    const divRow = document.createElement('div');
    divRow.setAttribute('class', 'row');

    // Delete Button
    const element = document.createElement('a');
    if (that.isDisabled || that.readOnly) {
      element.setAttribute('class', 'disabled');
    }
    const image = DELETE_BTN;
    element.innerHTML = image;
    element.addEventListener('click', () => {
      that.deleteTest()
    });
    element.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.deleteTest();
      } else if (event.keyCode === 9) {
        event.preventDefault();
        setTimeout(() => auditElement.focus(), 0);
      }

    });
    element.setAttribute('tabindex', '0');

    const divCol1 = document.createElement('div');
    divCol1.setAttribute('class', 'col-2 right-margin-1');

    divCol1.appendChild(element);

    // Audit Button
    const auditElement = document.createElement('a');
    const auditImage = AUDIT_BTN;
    auditElement.innerHTML = auditImage;
    auditElement.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('component', params.context.component);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentBarrier');
      that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
      that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Barriers Audit');
      that.router.navigate(['/task/assessmentSummary/auditHistory']);
    });
    auditElement.addEventListener('keydown', (event) => {
      if (event.keyCode === 13 || event.keyCode === 32) {
        that.dataService.addValueToSharedDataMap('component', params.context.component);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_ID, params.data.id);
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_TYPE, 'wr.dc.wp.model.AssessmentBarrier');
        that.dataService.addValueToSharedDataMap(that.AUDIT_ENTITY_COLUMN_DEFS, that.auditColumnDefs);
        that.dataService.addValueToSharedDataMap(that.AUDIT_PAGE_TITLE, 'Barriers Audit');
        that.router.navigate(['/task/assessmentSummary/auditHistory']);
      }

    });
    auditElement.setAttribute('tabindex', '0');

    const divCol2 = document.createElement('div');
    divCol2.setAttribute('class', 'col-1');
    divCol2.appendChild(auditElement);
    divRow.appendChild(divCol1);
    divRow.appendChild(divCol2);

    return divRow;
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  }

  saveAll() {
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    let allBarriers = [];
    if (this.gridApi !== undefined) {

      this.gridApi.stopEditing();
      this.gridApi.selectAll();

      this.isShowStyle = true;
      this.gridApi.redrawRows();
      this.isShowStyle = false;

      allBarriers = this.gridApi.getSelectedRows();
      this.gridApi.deselectAll();


      // Validation Code
      this.validationError = [];
      this.showError = false;
      let errorIndex = 0;
      let isHeaderPushed = false;
      allBarriers.forEach(selectedRow => {
        selectedRow.deleteSw = 'N';
        ++errorIndex;
        let errorText = '';
        if (selectedRow.barrierTypeCd === undefined || selectedRow.barrierTypeCd === 'Pick an option') {
          errorText = 'Barrier Type, ';
        } if (selectedRow.barrierCd === undefined || selectedRow.barrierCd === 'Pick an option') {
          errorText = errorText + 'Barrier, ';
        } if (selectedRow.beginDt === undefined || selectedRow.beginDt === "") {
          errorText = errorText + 'Begin Date, ';
        }
        if (this.dateUtil.compareDate(selectedRow.beginDt, selectedRow.endDt) === 1) {
          this.validationError.push('Row ' + errorIndex + ': ' + 'End Date should be greater than Start Date');
          this.showError = true;
        }

        if (errorText.length > 0) {
          if (!isHeaderPushed) {
            isHeaderPushed = true;
            this.validationError.push('Following fields are mandatory:');
          }

          errorText = errorText.substring(0, errorText.length - 2);
          this.validationError.push('Row ' + errorIndex + ': ' + errorText);
          this.showError = true;
        }

      });

    }
    if (!this.showError) {
      let count =0;
      for(let i=0; i<this.removeBarries.length; i++){
        count = 0;
        for(let j=0; j<allBarriers.length; j++){
          if(allBarriers[j].id === this.removeBarries[i].id){
            count =1;
          }
        }
        if(count === 0){
          allBarriers.push(this.removeBarries[i]);
        }
      }
      let familyFlag = 'N';
      let transFlag = 'N';
      let personalFlag = 'N';
      console.log(allBarriers);
      allBarriers.forEach(selectedRow => {
        console.log(selectedRow);
        selectedRow.barrierCd = this.selectedBarriersReverse[selectedRow.barrierTypeCd][selectedRow.barrierCd];
        selectedRow.barrierTypeCd = this.barrierTypeDescReverseJson[selectedRow.barrierTypeCd];
        selectedRow.beginDt = this.dateUtil.convertFormattedDateForServer(selectedRow.beginDt);
        selectedRow.endDt = this.dateUtil.convertFormattedDateForServer(selectedRow.endDt);

        if (selectedRow.deleteSw !== 'Y') {
          if (selectedRow.barrierTypeCd === 'FA') {
            familyFlag = 'Y';
          } else if (selectedRow.barrierTypeCd === 'TR') {
            transFlag = 'Y';
          } else if (selectedRow.barrierTypeCd === 'PE') {
            personalFlag = 'Y';
          }
        }
      });
      this.assessment.familyBarrierSw = this.familySw;
      this.assessment.personalBarrierSw = this.personalSw;
      this.assessment.transportationBarrierSw = this.transportSw;
      this.assessment.notes = this.notes;
      let conditionFalg = true;
      let errorMessage = '';
      if (this.familySw !== familyFlag) {
        errorMessage = 'Family Barrier'
        conditionFalg = false;
      }
      if (this.personalSw !== personalFlag) {
        conditionFalg = false;
        if (errorMessage === '') {
          errorMessage = 'Personal Barrier'
        } else {
          errorMessage = errorMessage + ', ' + 'Personal Barrier'
        }

      }
      if (this.transportSw !== transFlag) {
        conditionFalg = false;
        if (errorMessage === '') {
          errorMessage = 'Transportation Barrier'
        } else {
          errorMessage = errorMessage + ', ' + 'Transportation Barrier'
        }

      }

      if (conditionFalg) {
        const request = new RequestLoadAll(allBarriers, this.assessment);
        this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/saveBarrier', request).subscribe(
          (data) => {
            if (data.hasOwnProperty('errorCode')) {
              this.notificationService.error('Assessment-Barriers', this.userActionNotificationsMap.ERROR);
            } else {
              this.isChangeDetected = false;
              this.notificationService.success('Assessment-Barriers', this.userActionNotificationsMap.ADD);
              if (this.assessmentId > 0) {

                this.load(new RequestLoad(this.assessmentId));
                this.removeBarries = [];
              }

            }
            this.validationError = [];
            this.showError = false;
          }, response => {

            this.notificationService.error('Assessment-Barriers', this.userActionNotificationsMap.ERROR);
          }, () => {

          });
      } else {
        this.notificationService.warn('Assessment-Barriers', errorMessage + ' Required');
      }
      allBarriers.forEach(selectedRow => {
        selectedRow.barrierTypeCd = this.barrierTypeDescJson[selectedRow.barrierTypeCd];
        selectedRow.barrierCd = this.allBarriersNames[selectedRow.barrierTypeCd][selectedRow.barrierCd];
        selectedRow.beginDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.beginDt);
        selectedRow.endDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.endDt);
      });
    }

  }


  load(request) {
    this.validationError = [];
    this.showError = false;
    this.http.post<RequestLoadAll>(this.serverConstants.SERVER_API_URL + '/assessment-summary/loadObjects/barrier', request).subscribe(
      (data) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('Assessment-Barriers', this.userActionNotificationsMap.ERROR);
        } else {
          if (data !== null && data !== undefined) {
            this.barriers = data.barriers;
            this.barriers.forEach(selectedRow => {

              selectedRow.barrierTypeCd = this.barrierTypeDescJson[selectedRow.barrierTypeCd];
              selectedRow.barrierCd = this.allBarriersNames[selectedRow.barrierTypeCd][selectedRow.barrierCd];
              selectedRow.beginDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.beginDt);
              selectedRow.endDt = this.dateUtil.convertFormattedDateFromServer(selectedRow.endDt);
            });

            this.assessment = data.assessment;
            if (this.assessment !== undefined) {
              if (this.assessment.statusCd !== undefined && (this.assessment.statusCd === 'CO') || (this.assessment.statusCd === 'CN')) {
                this.isDisabled = true;
                this.tabIndex = '0';
                this.getColumnDefinitions();
              }
              this.familySw = this.assessment.familyBarrierSw;
              this.personalSw = this.assessment.personalBarrierSw;
              this.transportSw = this.assessment.transportationBarrierSw;
              if (this.assessment.notes != null && this.assessment.notes !== undefined) {
                this.notes = this.assessment.notes;
              } else {
                this.notes = '';
              }

              this.radioFamily();
              this.radioPersonal();
              this.radioTransport();
            }
          } else {
            this.barriers = [];

          }
        }
      }, response => {

        this.notificationService.error('Assessment-Barriers', this.userActionNotificationsMap.ERROR);
      }, () => {

      });
  }
  reset() {
    this.showError = false;
    if (this.assessmentId > 0) {

      this.load(new RequestLoad(this.assessmentId));

    }
  }

  addTests() {
    const response = this.gridApi.updateRowData({
      add: [new Barries(this.assessment, 'N', this.dateUtil.getFormattedSystemDateFromModel())]
    });
    let index;
    response.add.forEach(element => {
      index = element.rowIndex;
    });
    this.gridApi.setFocusedCell(index, 'barrierTypeCd');
    this.gridApi.startEditingCell({
      rowIndex: index,
      colKey: 'barrierTypeCd'
    });
    this.gridApi.paginationGoToPage( Math.floor(index / 10) );
  }
  deleteTest() {
    const selectedData = this.gridApi.getSelectedRows();
    this.gridApi.updateRowData({ remove: selectedData });

    selectedData.forEach(element => {
      if (element.id > 0) {
        element.deleteSw = 'Y';
        this.removeBarries.push(element);
      }

    })
  }
  radioFamily() {

    if (this.familySw === 'Y') {
      if (!this.selectedBarriers.includes(this.barrierTypeDescJson['FA'])) {
        this.selectedBarriers.push(this.barrierTypeDescJson['FA']);
      }

      this.isFamily = true;
    } else {

      const indexArray = this.selectedBarriers.indexOf(this.barrierTypeDescJson['FA']);
      if (indexArray > -1) {
        this.selectedBarriers.splice(indexArray, 1);
      }
      this.isFamily = false;
      this.removeFromGrid('FA');
    }
  }

  radioPersonal() {
    if (this.personalSw === 'Y') {
      if (!this.selectedBarriers.includes(this.barrierTypeDescJson['PE'])) {
        this.selectedBarriers.push(this.barrierTypeDescJson['PE']);
      }
      this.isPersonal = true;
    } else {

      const indexArray = this.selectedBarriers.indexOf(this.barrierTypeDescJson['PE']);
      if (indexArray > -1) {
        this.selectedBarriers.splice(indexArray, 1);
      }
      this.isPersonal = false;
      this.removeFromGrid('PE');
    }
  }

  radioTransport() {
    if (this.transportSw === 'Y') {
      if (!this.selectedBarriers.includes(this.barrierTypeDescJson['TR'])) {
        this.selectedBarriers.push(this.barrierTypeDescJson['TR']);
      }
      this.isTransport = true;
    } else {
      const indexArray = this.selectedBarriers.indexOf(this.barrierTypeDescJson['TR']);
      if (indexArray > -1) {
        this.selectedBarriers.splice(indexArray, 1);
      }

      this.isTransport = false;
      this.removeFromGrid('TR');
    }
  }
  removeFromGrid(barrierType) {
    if (this.gridApi !== undefined) {

      this.gridApi.stopEditing();
      this.gridApi.selectAll();
      const allBarriers = this.gridApi.getSelectedRows();
      this.gridApi.deselectAll();
      allBarriers.forEach(element => {
        if (this.barrierTypeDescReverseJson[element.barrierTypeCd] === barrierType) {
          this.gridApi.updateRowData({ remove: [element] });
          if (element.id > 0) {
            element.deleteSw = 'Y';
            console.log(element);
            this.removeBarries.push(element);
            console.log(this.removeBarries);
          }
        }


      });
    }
  }

}


class RequestLoad {
  constructor(
    public id: Number,

  ) {
  }
}

class Barries {
  constructor(
    public assessment: AssessmentSummary,
    public deleteSw: String,
    public beginDt?: any,
    public endDt?: any,
    public barrierCd?: string,
    public barrierTypeCd?: string,
    public id?: any,
    public recordVersion?: number

  ) {
  }
}


class RequestLoadAll {
  constructor(
    public barriers: any,
    public assessment: AssessmentSummary,
  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/barriers/barriers.component.ts